import { List, Theme } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import uuid from 'uuid';
import './DashboardList.scss';

export interface IDashboardListRow {
  id: string;
  value: string;
  label: string;
}

export function getDefaultDashboardListRow(): IDashboardListRow {
  return { label: '---', value: '', id: uuid() };
}

export interface IDashboardListProps<T> {
  hover: boolean;
  renderItem: (item: T) => void;
  rowItems: T[];
  className?: string | object;
  theme: Theme.DARK | Theme.LIGHT;
}

function DashboardList<T>({ rowItems, className, hover, theme, renderItem }: IDashboardListProps<T>) {
  const classes = classNames('dashboard-list', theme, className);

  return (
    <List stroke={true} className={classes} hover={hover}>
      {rowItems.map(renderItem)}
    </List>
  );
}

export default DashboardList;
